import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgIllnessDizzy = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.0417 21.3542V16.1333C19.0243 15.2232 19.756 14.0754 20.1664 12.8006C20.5768 11.5257 20.6521 10.1666 20.3851 8.85417"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.98002 8.85417C4.43585 10.1425 3.93502 11.5525 3.37502 13.0042C3.33869 13.0989 3.32592 13.201 3.33782 13.3017C3.34971 13.4025 3.38592 13.4988 3.44332 13.5825C3.50072 13.6661 3.57759 13.7345 3.66731 13.7819C3.75703 13.8292 3.85691 13.854 3.95835 13.8542H5.54169V16.3542C5.54169 17.0172 5.80508 17.6531 6.27392 18.1219C6.74276 18.5908 7.37865 18.8542 8.04169 18.8542H9.29169V21.3542"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4167 3.13333C19.3192 3.59083 20.5417 4.3 20.5417 5.10416C20.5417 6.485 16.9042 7.60416 12.4167 7.60416"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.16675 6.70167C5.00008 6.26834 4.29175 5.71167 4.29175 5.10417C4.29175 3.72334 7.92925 2.60417 12.4167 2.60417"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9167 2.91667C14.9996 2.91667 15.0791 2.9496 15.1377 3.0082C15.1963 3.06681 15.2292 3.14629 15.2292 3.22917"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6042 3.22917C14.6042 3.14629 14.6372 3.06681 14.6958 3.0082C14.7544 2.9496 14.8339 2.91667 14.9167 2.91667"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9167 3.54167C14.8339 3.54167 14.7544 3.50875 14.6958 3.45014C14.6372 3.39154 14.6042 3.31205 14.6042 3.22917"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2292 3.22917C15.2292 3.31205 15.1963 3.39154 15.1377 3.45014C15.0791 3.50875 14.9996 3.54167 14.9167 3.54167"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.29175 6.66667C9.37463 6.66667 9.45411 6.6996 9.51272 6.7582C9.57132 6.81681 9.60425 6.89629 9.60425 6.97917"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.97925 6.97917C8.97925 6.89629 9.01217 6.81681 9.07078 6.7582C9.12938 6.6996 9.20887 6.66667 9.29175 6.66667"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.29175 7.29167C9.20887 7.29167 9.12938 7.25875 9.07078 7.20014C9.01217 7.14154 8.97925 7.06205 8.97925 6.97917"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.60425 6.97917C9.60425 7.06205 9.57132 7.14154 9.51272 7.20014C9.45411 7.25875 9.37463 7.29167 9.29175 7.29167"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgIllnessDizzy.displayName = 'SvgIllnessDizzy';
export default SvgIllnessDizzy;
